<template>
    <div id="coreCompetence">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap" id="canvasBox">
                <canvas></canvas>
                <h3>一样的服务，不一样的能力</h3>
            </div>
        </div>
        <!--核心能力列表-->
        <div class="coreCompetenceBox">
            <div class="coreCompetenceList" style="margin-bottom: 148px;">
                <div class="textWrap">
                    <div class="coreTitle">数据整合</div>
                    <div class="coreVal">
                        拥有海量经过技术挖掘、清洗加工结合商业参数验证出来的优质参数；参数具有广维度特性，其中包括社交、风控、金融、保险、电商、KOL等维度
                    </div>
                </div>
                <div class="imgWrap">
                    <img src="../../assets/img/coreCompetence/海量优质数据-上层.png" class="topImg"/>
                    <img src="../../assets/img/coreCompetence/海量优质数据-中层.png" class="centerImg"/>
                    <img src="../../assets/img/coreCompetence/海量优质数据-下层.png" class="bottomImg"/>
                </div>
            </div>
            <div class="coreCompetenceList" style="margin-bottom: 183px;">
                <div class="imgWrap">
                    <img src="../../assets/img/coreCompetence/极客数据团队-上层.png" class="topImg"/>
                    <img src="../../assets/img/coreCompetence/极客数据团队-中层.png" class="centerImg"/>
                    <img src="../../assets/img/coreCompetence/极客数据团队-下层.png" class="bottomImg"/>
                </div>
                <div class="textWrap">
                    <div class="coreTitle">参数应用</div>
                    <div class="coreVal">
                        通过机器学习技术进行聚类分析，学习用户行为，建立数学模型，输出结果后根据实际场景提供相应的服务，包括市场动态分析、产品精准营销、用户画像评级、⻛险预警等服务
                    </div>
                </div>
            </div>
            <div class="coreCompetenceList" style="margin-bottom: 114px;">
                <div class="textWrap">
                    <div class="coreTitle">极客团队</div>
                    <div class="coreVal">
                        全海归属性极客级技术团队与优质的业务数据分析团队，曾在金融及部分金融量化领域全国排名前三，拥有从商业分析到数据生态搭建的完善体系
                    </div>
                </div>
                <div class="imgWrap">
                    <img src="../../assets/img/coreCompetence/神经网络计算-上层.png" class="topImg"/>
                    <img src="../../assets/img/coreCompetence/神经网络计算-中层.png" class="centerImg"/>
                    <img src="../../assets/img/coreCompetence/神经网络计算-下层.png" class="bottomImg"/>
                </div>
            </div>
            <div class="coreCompetenceList" style="margin-bottom: 217px;">
                <div class="imgWrap">
                    <img src="../../assets/img/coreCompetence/安全可靠服务-上层.png" class="topImg"/>
                    <img src="../../assets/img/coreCompetence/安全可靠服务-中层.png" class="centerImg"/>
                    <img src="../../assets/img/coreCompetence/安全可靠服务-下层.png" class="bottomImg"/>
                </div>
                <div class="textWrap">
                    <div class="coreTitle">安全服务</div>
                    <div class="coreVal">
                        保障大数据交换时的信息安全、保护终端数据和个人数据隐私、保证合法合规的前提下，在多参与方或多计算节点之间开展高效率的机器学习
                    </div>
                </div>
            </div>
            <div class="coreCompetenceList">
                <div class="textWrap">
                    <div class="coreTitle">数字营销服务</div>
                    <div class="coreVal">
                        海量独家合作高质媒体，全网多场景流量覆盖，线上线下多维数据整合，根据用户需求提供定制化的营销解决方案，采取精细化运营方式，实时反馈营销效果数据，致力打造行业领先的数字营销服务
                    </div>
                </div>
                <div class="imgWrap">
                    <img src="../../assets/img/coreCompetence/全网媒体触达-上层.png" class="topImg"/>
                    <img src="../../assets/img/coreCompetence/全网媒体触达-中层.png" class="centerImg"/>
                    <img src="../../assets/img/coreCompetence/全网媒体触达-下层.png" class="bottomImg"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import coreCompetenceCanvas from "../../assets/js/coreCompetenceCanvas"

    export default {
        name: "coreCompetence",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();

            coreCompetenceCanvas();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByTagName("h3")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("coreCompetenceList")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("coreCompetenceList")[1], "fadeInUp");
                this.$animate(document.getElementsByClassName("coreCompetenceList")[2], "fadeInUp");
                this.$animate(document.getElementsByClassName("coreCompetenceList")[3], "fadeInUp");
                this.$animate(document.getElementsByClassName("coreCompetenceList")[4], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #coreCompetence {
        .bannerWrap {
            position: relative;
            background: #010101;

            .contentWrap {
                h3 {
                    margin-top: -32px;
                }

                canvas {
                    position: absolute;
                    right: 0;
                }
            }
        }

        .coreCompetenceBox {
            width: 1200px;
            margin: 0 auto;
            padding-top: 103px;

            .coreCompetenceList {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .textWrap {
                    width: 360px;
                    margin: 0 100px;

                    .coreTitle {
                        margin-bottom: 30px;
                        font-size: 60px;
                        color: #152346;
                        text-align: justify;
                    }

                    .coreVal {
                        opacity: 0.6;
                        font-size: 16px;
                        color: #152346;
                        text-align: justify;
                        line-height: 28px;
                    }
                }

                .imgWrap {
                    position: relative;
                    width: 571px;
                    height: 301px;

                    .bottomImg {
                        width: 100%;
                    }

                    .centerImg {
                        position: absolute;
                        left: 51%;
                        transform: translateX(-50%);
                        animation: centerImgAnimate 2s cubic-bezier(0.42, 0, 0.58, 1) infinite;
                        animation-direction: alternate;
                    }

                    .topImg {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }

    /*centerImg 动画*/
    @keyframes centerImgAnimate {
        from {
            bottom: 150px;
        }
        to {
            bottom: 210px;
        }
    }
</style>